import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { InventarioFisicoService } from 'src/app/services/inventario-fisico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-modal-consulta',
  templateUrl: './modal-consulta.component.html',
  styleUrls: ['../exist-inventario-fisico.component.scss'],
  providers: [SecurityService],
})
export class ExistInventarioFisicoModalConsultaComponent implements OnInit {

  @ViewChild('consultaDoc', { static: true }) modalConsultaDoc: ModalDirective;

  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number

  movimiento: any
  detalleDocumentoAll: any[]
  detalleDocumento: any[]
  cantidad: any
  total_dif: any
  loading: boolean
  paginationContext: PaginationContext = new PaginationContext()
  private currentPayload: any = null
  inventario_totales: any = null
  optionsBodega: Array<any> = [];
  optionsEstado: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private inventarioFisicoService: InventarioFisicoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO/CONSULTA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10

    this.createForms()
  }

  private createForms() {
    this.formHeader = this.fb.group({
      bodega: [null],
      estado: [null],
      referencia: [null],
    });
  }

  loadInventarFisicoByCodigo(codigo) {
    this.cleanup()
    this.loadInventarioFisico(
      {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        codigo
      }
    )
  }

  cleanup() {
    this.detalleDocumentoAll = null
    this.detalleDocumento = null
    this.loading = false
    this.formValidatorsService.reset(this.formHeader)
  }

  loadInventarioFisico(mov) {
    const { rut_empresa, sucursal_codigo, codigo } = mov
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.currentPayload = inputParams

    this.loading = true
    this.inventarioFisicoService.obtenerConsultaInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        this.modalConsultaDoc.hide()
        return
      }

      this.movimiento = respuesta
      this.fillAndSetFormControls(this.movimiento)

      const { detalleInventarioFisico } = respuesta

      this.paginationContext.RecordsCount = detalleInventarioFisico.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1 // paginaActual

      this.detalleDocumentoAll = _.cloneDeep(detalleInventarioFisico)
      this.showPage(1)
      this.calculateTotales()
      this.loading = false
      this.modalConsultaDoc.show()
    })
  }

  calculateTotales() {
    this.cantidad = this.detalleDocumentoAll.length
    this.total_dif = this.detalleDocumentoAll.reduce((prev, cur) => prev + cur.valor_dif, 0);
    //this.total_dif= _.sumBy(this.detailsData.reduce(this.detalleDocumentoAll, 'valor_dif'), 0)
  }
  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.detalleDocumento = _.slice(this.detalleDocumentoAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  fillAndSetFormControls(mov) {
    // bodegas
    this.optionsBodega = [{ value: mov.bodega_codigo, label: mov.bodega_nombre }]
    this.formHeader.get('bodega').setValue(mov.bodega_codigo)

    // estados
    this.optionsEstado = [{ value: mov.estado_inventario_codigo, label: mov.estado_inventario_nombre }]
    this.formHeader.get('estado').setValue(mov.estado_inventario_codigo)

    this.formHeader.get('referencia').setValue(mov.observacion)


    // disable controls
    this.formHeader.get('bodega').disable()
    this.formHeader.get('estado').disable()
    this.formHeader.get('referencia').disable()
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    // inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.inventarioFisicoService.obtenerConsultaInventarioFisicoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }

}
